import moment from 'moment';
import { VideoLink, StreamingLink, WebLink } from "./Link";
import { Photo } from "./Photo";
import { FrontendEvent } from "./Event";
import { BillingDetails } from "./Billing";
import { Invoice } from "./Billing";
import { CharityConcert } from "./Concert";
import { Location } from "./Location";
import { BasePerson as Person } from "./Person";
import { GLOBAL_CURRENCIES } from '../common/constants';
import { Modal } from 'bootstrap';

export class Artist {
  constructor(data) {
    if (data.type == "Artist") {
      return this;
    }
    var self = this;
    self.type = "Artist";

    self.rootvm = data.rootvm;

    // Admin Action Profile
    self.charity = ko.observable(data.charity);
    self.charity_external = ko.observable(data.charity_external);

    self.artist_uuid = ko.observable(data.artist_uuid);
    self.artist_name = ko.observable(data.artist_name);
    self.person_uuid = ko.observable(data.person_uuid);

    self.billing_details_uuid = ko.observable(data.billing_details_uuid);

    self.billing_details = ko.observable(new BillingDetails({}));
    if (data.billing_details) {
      self.billing_details(new BillingDetails(data.billing_details));
    }

    // how many events
    self.total_invite_count = data.total_invite_count;
    self.total_booking_count = data.total_booking_count;

    // Sections Complete
    const sections_complete = data.sections_complete || {};
    self.basic_complete = ko.observable(sections_complete.basic_complete);
    self.music_complete = ko.observable(sections_complete.music_complete);
    self.media_complete = ko.observable(sections_complete.media_complete);
    self.your_music_complete = ko.observable(
      sections_complete.your_music_complete
    );
    self.experience_complete = ko.observable(
      sections_complete.experience_complete
    );
    self.video_message_complete = ko.observable(
      sections_complete.video_message_complete
    );
    self.bank_account_complete = ko.observable(
      sections_complete.bank_account_complete
    );
    self.bank_sca_complete = ko.observable(sections_complete.bank_sca_complete);
    // Bank check mark: saved bank account plus completed SCA enrollment.
    self.bank_check_complete = ko.pureComputed(function () {
      return self.bank_account_complete() && self.bank_sca_complete();
    });
    self.kyc_complete = ko.observable(sections_complete.kyc_complete);
    self.billing_details_complete = ko.observable(
      sections_complete.billing_details_complete
    );
    self.booking_information_complete = ko.observable(
      sections_complete.booking_information_complete
    );
    self.video_message_complete = ko.observable(
      sections_complete.video_message_complete
    );

    self.kyc_error = ko.observable(data.kyc_error);
    self.kyc_in_progress = ko.observable(data.kyc_in_progress);

    self.no_gig_options = ko.observable(data.no_gig_options);
    self.allow_payout_transfer = ko.observable(data.allow_payout_transfer);
    self.payouts_enabled = ko.observable(data.payouts_enabled);

    // This is actually set on the person -- but we'll keep it here on
    // as a first class on the artist as well
    self.allow_attachments = ko.observable(data.allow_attachments);

    self.new_allow_payout_transfer = ko.observable(data.allow_payout_transfer);
    self.new_no_gig_options = ko.observable(data.no_gig_options);

    self.all_sections_complete = ko.pureComputed(function () {
      return (
        self.basic_complete() &&
        self.music_complete() &&
        self.media_complete() &&
        self.your_music_complete() &&
        self.bank_account_complete() &&
        self.billing_details_complete() &&
        self.booking_information_complete()
      );
    });

    self.inserted = ko.observable(new moment(data.inserted));

    self.active_since_year = ko.pureComputed(function () {
      if (self.inserted()) {
        return self.inserted().format("YYYY");
      }
    });

    self.deleted = ko.observable(data.deleted);
    self.username = ko.observable(data.username);

    self.slogan = ko.observable(data.slogan);
    self.admin_promo_text = ko.observable(data.admin_promo_text);
    self.atmospheres = ko.observableArray(data.atmospheres || []);
    self.show_all_atmosphereTypes = ko.observable(false);
    self.set_options = ko.observableArray(data.set_options || []);
    self.show_all_setOptions = ko.observable(false);
    self.lineup = ko.observableArray(data.lineup || []);
    self.show_all_lineupTypes = ko.observable(false);
    self.genres = ko.observableArray(data.genres || []);
    self.show_all_genres = ko.observable(false);

    self.last_kyc_reminder_email_sent = ko.observable(
      data.last_kyc_reminder_email_sent
    );

    self.last_sca_reminder_email_sent = ko.observable(
      data.last_sca_reminder_email_sent
    );

    self.sca_invoice_number = ko.observable();

    self.send_sca_email = async function () {
      const invoiceNumber = self.sca_invoice_number();
      if (!invoiceNumber) {
        notyf.error("Please enter an invoice number");
        return;
      }
      try {
        const response = await fetch("/api/artist/sca-reminder-email", {
          method: "POST",
          headers: { "Content-Type": "application/json; charset=utf-8" },
          body: JSON.stringify({
            artist_uuid: self.artist_uuid(),
            invoice_number: parseInt(invoiceNumber)
          })
        });
        const data = await response.json();
        if (data.success) {
          notyf.success("SCA email sent");
          self.last_sca_reminder_email_sent(data.last_sent);
        } else {
          notyf.error(data.message);
        }
      } catch (error) {
        notyf.error("Failed to send SCA email");
        console.log(error);
      }
    };

    self.last_bank_account_reminder_email_sent = ko.observable(
      data.last_bank_account_reminder_email_sent
    );

    self.bank_account_invoice_number = ko.observable();

    self.send_bank_account_email = async function () {
      const invoiceNumber = self.bank_account_invoice_number();
      try {
        const response = await fetch("/api/artist/bank-account-reminder-email", {
          method: "POST",
          headers: { "Content-Type": "application/json; charset=utf-8" },
          body: JSON.stringify({
            artist_uuid: self.artist_uuid(),
            invoice_number: invoiceNumber ? parseInt(invoiceNumber) : null
          })
        });
        const data = await response.json();
        if (data.success) {
          notyf.success("Bank account email sent");
          self.last_bank_account_reminder_email_sent(data.last_sent);
        } else {
          notyf.error(data.message);
        }
      } catch (error) {
        notyf.error("Failed to send bank account email");
        console.log(error);
      }
    };

    self.copyright_collective = ko.observable(data.copyright_collective);

    self.admin_ranking = ko.observable(data.admin_ranking);
    self.new_admin_ranking = ko.observable(data.admin_ranking);

    self.fee_currency = ko.observable(
      ko.utils.arrayFirst(GLOBAL_CURRENCIES, function (item) {
        if (item.iso_currency_code == data.fee_currency) {
          return item;
        }
      })
    );

    self.fee_min = ko.observable(data.fee_min);
    self.fee_mid = ko.observable(data.fee_mid);
    self.fee_max = ko.observable(data.fee_max);

    self.sounds_like_extra_notes = ko.observable(data.sounds_like_extra_notes);
    self.similar_artists = ko.observableArray(data.similar_artists || []);
    self.set_list = ko.observableArray(data.set_list || []);
    self.requires = ko.observable(data.requires);
    self.description = ko.observable(data.description);
    self.availability = ko.observable(data.availability);
    self.buy_url = ko.observable(data.buy_url);
    self.notes = ko.observable(data.notes);

    self.member_count = ko.observable(data.member_count);

    self.accepted_new_tc = ko.observable(data.accepted_new_tc);

    // video botschaft
    self.video_message_opt_in = ko.observable(data.video_message_opt_in);
    self.video_message_min_fee = ko.observable(data.video_message_min_fee);
    self.video_message_video_uuid = ko.observable(
      data.video_message_video_uuid
    );
    self.video_message_description = ko.observable(
      data.video_message_description
    );
    self.video_message_songs = ko.observableArray(
      data.video_message_songs || []
    );

    self.video_message_link = ko.observable();

    if (data.video_message_link) {
      self.video_message_link(new VideoLink(data.video_message_link));
    }

    self.share_phone = ko.observable(data.share_phone);

    self.profile_photo = ko.observable(new Photo(data.profile_photo));
    self.profile_photo_uuid = ko.observable(data.profile_photo_uuid);

    self.discount_code_sample = ko.pureComputed(function () {
      if (self.profile_photo()) {
        return self.profile_photo().discount_code_sample_de();
      }
    });

    self.pro_invoices = ko.observableArray([]);

    self.version = ko.observable(data.version);

    self.distance_in_m = ko.observable();

    // full text search
    self.full_text_highlight = ko.observable(data.full_text_highlight);

    if (data.distance_in_m != null || data.distance_in_m != undefined) {
      self.distance_in_m(data.distance_in_m);
    }

    self.event_types = ko.observable({
      sofaconcert: ko.observableArray(),
      birthday: ko.observableArray(),
      special_occasion: ko.observableArray(),
      wedding: ko.observableArray(),
      corporate_event: ko.observableArray(),
      events_surprise: ko.observableArray(),
    });

    self.event_type_keys = ko.pureComputed(function () {
      var keys = [];
      for (var key in self.event_types()) {
        if (self.event_types().hasOwnProperty(key)) {
          keys.push(key);
        }
      }
      return keys;
    });

    if (ko.isObservable(data.event_types)) {
      self.event_types = data.event_types;
    } else {
      for (const event_type in data.event_types) {
        self.event_types()[event_type](data.event_types[event_type]);
      }
    }

    self.has_favorite_gigs = ko.pureComputed(function () {
      for (var i = 0; i < self.event_type_keys().length; i++) {
        event_type_list = self.event_types()[self.event_type_keys()[i]];
        if (event_type_list != undefined && event_type_list().length > 0) {
          return true;
        }
      }
      return false;
    });

    self.rating_average = ko.observable();
    self.rating_count = ko.observable();
    self.resp_rating = ko.observable();
    self.recommended_artists = ko.observableArray();

    if (data.rating_stats) {
      self.rating_average(data.rating_stats.average);
      self.rating_count(data.rating_stats.count);
    }

    self.rating_star_css = function (star_index) {
      if (self.rating_average()) {
        if (
          self.rating_average() - star_index > 0 &&
          self.rating_average() - star_index < 0.5
        ) {
          return "mdi-star-half";
        } else if (self.rating_average() - star_index <= 0) {
          return "light-grey";
        } else {
          return;
        }
      } else {
        return "light-grey";
      }
    };

    self.pretty_genres = ko.computed(function () {
      return self.genres().join(", ");
    });

    self.video_links = ko.observableArray([]);

    if (data.video_links) {
      self.video_links(
        ko.utils.arrayMap(data.video_links || [], function (x) {
          return new VideoLink(x);
        })
      );
    }

    self.streaming_links = ko.observableArray([]);

    if (data.streaming_links) {
      self.streaming_links(
        ko.utils.arrayMap(data.streaming_links || [], function (x) {
          return new StreamingLink(x);
        })
      );
    }

    self.has_media = ko.computed(function () {
      return self.video_links().length > 0 || self.streaming_links().length > 0;
    });

    self.web_links = ko.observableArray([]);

    if (data.web_links) {
      self.web_links(
        ko.utils.arrayMap(data.web_links || [], function (x) {
          return new WebLink(x);
        })
      );
    }

    self.locations = ko.observableArray([]);

    if (data.locations) {
      self.locations(
        ko.utils.arrayMap(data.locations || [], function (x) {
          return x.location_name;
        })
      );
    }

    self.location_objs = ko.observableArray([]);

    if (data.locations) {
      self.location_objs(
        ko.utils.arrayMap(data.locations || [], function (x) {
          return new Location(x);
        })
      );
    }

    self.charity_concert = ko.observable();
    if (data.charity_concert) {
      data.charity_concert.rootvm = self.rootvm;
      self.charity_concert(new CharityConcert(data.charity_concert));
    }

    if (data.pro_invoices) {
      self.pro_invoices(
        ko.utils.arrayMap(data.pro_invoices || [], function (x) {
          x.rootvm = self.rootvm;
          return new Invoice(x);
        })
      );
    }

    self.current_state = ko.observable(
      new ArtistStateAction(data.current_state || {})
    );
    self.new_state = ko.observable();
    if (data.current_state) {
      self.new_state(data.current_state.artist_state);
    }

    // Full state history (admin only), newest first. Each entry carries its
    // own effective range so the modal can show how long each state lasted.
    self.artist_state_history = ko.observableArray(
      (data.artist_state_history || []).map(function (x) {
        x.rootvm = self.rootvm;
        return new ArtistStateAction(x);
      })
    );

    self.is_published = function () {
      return (
        self.current_state() &&
        self.current_state().artist_state() &&
        self.current_state().artist_state() != "created" &&
        self.current_state().artist_state() != "removed"
      );
    };

    self.person = ko.observable();

    // Has to do with the logged in user
    self.is_favorite = ko.observable(data.is_favorite || false);
    if (
      self.rootvm &&
      self.rootvm.type == "SofaConcertsBaseViewModel" &&
      !self.rootvm.user_logged_in()
    ) {
      self.is_favorite(
        self.rootvm
          .webapp_session()
          .user()
          .guest_fav_artist_uuids.indexOf(self.artist_uuid()) != -1 || false
      );
    }
    self.upcoming_events = ko.observableArray([]);
    self.past_events = ko.observableArray([]);

    self.feedback = ko.observableArray([]);

    self.online_concert = ko.observable(data.online_concert ?? false);
    self.corporate_behaviour = ko.observable(data.corporate_behaviour);
    self.new_corporate_behaviour = ko.observable(data.corporate_behaviour);
    self.video_quality = ko.observable(data.video_quality);
    self.new_video_quality = ko.observable(data.video_quality);
    self.spoken_languages = ko.observableArray(data.spoken_languages || []);
    self.new_spoken_language = ko.observable();
    self.song_languages = ko.observableArray(data.song_languages || []);
    self.new_song_language = ko.observable();
    self.instruments = ko.observableArray(data.instruments || []);
    self.new_instrument = ko.observable();
    self.bypass_attempts = ko.observable(data.bypass_attempts || 0);

    // Profile texts (description, notes, requires, slogan) with contact
    // details in them, as found by the admin profile check.
    self.profile_filter_fields = ko.observableArray(data.profile_filter_fields ?? []);
    self.recommendation_text = ko.observable(data.recommendation_text);

    // Computables
    //
    self.is_pro = ko.computed(function () {
      return self.version() == "pro";
    });

    self.pro_expiration = ko.computed(function () {
      if (self.is_pro() && self.current_state().effective_start()) {
        return self.current_state().effective_start().clone().add(1, "year");
      } else {
        return moment();
      }
    });

    self.locations_pretty = ko.computed(function () {
      return self.locations().join(", ");
    });

    self.distance_in_km = ko.computed(function () {
      if (self.distance_in_m() != undefined && self.distance_in_m() != null) {
        return Math.round(self.distance_in_m() / 1000) + " km";
      }
    });

    self.budget_pop_title = ko.pureComputed(function () {
      if (typeof i18nextko != "undefined" && i18nextko.i18n.translator) {
        return i18nextko.i18n.translator.translate("search.budget.help.title");
      }
    });

    self.budget_pop_content = ko.computed(function () {
      if (
        typeof i18nextko != "undefined" &&
        i18nextko.i18n.translator &&
        self.rootvm &&
        self.rootvm.exchange_rates &&
        self.rootvm.exchange_rates() != undefined
      ) {
        if (self.fee_min() <= 0) {
          return i18nextko.i18n.translator.translate("search.budget.request");
        } else {
          if (self.rootvm.selected_global_currency() && self.fee_currency()) {
            var fee_min = self.fee_min();
            var fee_mid = self.fee_mid();
            var fee_max = self.fee_max();
            if (
              self.rootvm.selected_global_currency() !=
              self.fee_currency().iso_currency_code
            ) {
              fee_min = global_currency_exchange(
                fee_min,
                self.fee_currency().iso_currency_code,
                self.rootvm.selected_global_currency(),
                self.rootvm.exchange_rates()
              );

              fee_mid = global_currency_exchange(
                fee_mid,
                self.fee_currency().iso_currency_code,
                self.rootvm.selected_global_currency(),
                self.rootvm.exchange_rates()
              );
              fee_max = global_currency_exchange(
                fee_max,
                self.fee_currency().iso_currency_code,
                self.rootvm.selected_global_currency(),
                self.rootvm.exchange_rates()
              );
            }
            return i18nextko.i18n.translator.translate(
              "search.budget.help.artist",
              {
                min_fee: fee_min,
                mid_fee: fee_mid,
                max_fee: fee_max,
                currency: self.rootvm.selected_global_currency_full().symbol,
              }
            );
          }
        }
      }
    });

    // Functions
    self.update_person = function (person_data) {
      person_data.artist = self;
      self.person(new Person(person_data));
    };

    if (data.person && typeof data.person != "function") {
      // make sure we don't recreate the artist
      data.person.rootvm = self.rootvm;
      data.person.artist = {};
      self.update_person(data.person);
    }

    // Lookups
    //
    self.lookup_public_events = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/artist/events?" +
          self.rootvm.frontend_web_version(),
        type: "GET",
        cache: true,
        data: {
          artist_uuid: self.artist_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.upcoming_events(
              ko.utils.arrayMap(data.upcoming_events || [], function (x) {
                x.rootvm = self.rootvm;
                return new FrontendEvent(x);
              })
            );

            self.past_events(
              ko.utils.arrayMap(data.past_events || [], function (x) {
                x.rootvm = self.rootvm;
                return new FrontendEvent(x);
              })
            );
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.lookup_feedback = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/artist/feedback?" +
          self.rootvm.frontend_web_version(),
        type: "GET",
        cache: true,
        data: {
          artist_uuid: self.artist_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.feedback(
              ko.utils.arrayMap(data.feedback || [], function (x) {
                x.rootvm = self.rootvm;
                return new ArtistFeedback(x);
              })
            );
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.lookup_details = async () => {
      const url = scvm.web_host + "/api/admin/artist";
      const params = new URLSearchParams({
        artist_uuid: self.artist_uuid(),
      });
      const request = new Request(url + "?" + params.toString(), {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      });
      const response = await fetch(request);
      const data = await response.json();
      if (data.success) {
        self = new Artist(data.artist);
        return self;
      } else {
        console.error(data.pgcode, data.pgerror);
        throw new Error(data.message);
      }
    };

    self.lookup_resp_rating = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url:
          self.rootvm.web_host +
          "/api/artist/resp-rating?" +
          self.rootvm.frontend_web_version(),
        cache: true,
        type: "GET",
        data: {
          artist_uuid: self.artist_uuid(),
        },
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          if (data.success) {
            self.resp_rating(data.resp_rating || undefined);
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {
          self.rootvm.is_busy(false);
        },
      });
    };

    self.lookup_rcmd_artists = function (
      latitude,
      longitude,
      cnt,
      location_uuid,
      host_uuid
    ) {
      return $.ajax({
        url: self.rootvm.web_host + "/api/artist/recommended-artists?",
        cache: true,
        type: "GET",
        data: {
          artist_uuid: self.artist_uuid(),
          latitude: latitude || null,
          longitude: longitude || null,
          count: cnt || 3,
          location_uuid: location_uuid || null,
          host_uuid: host_uuid || null,
        },
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          if (data.success) {
            self.recommended_artists(data.recommended_artists || []);
          }
        },
        error: function (data) {
          console.log(data);
        },
        complete: function () {},
      });
    };

    self.login_link = ko.observable();
    self.get_login_link = function () {
      self.login_link(undefined);

      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/get-login-user-link",
        type: "GET",
        data: {
          person_uuid: self.person_uuid(),
        },
        contentType: "application/json; charset=utf-8",

        success: function (result) {
          var login_link;
          login_link = result.login_link;
          self.login_link(login_link);
        },

        error: function (data) {
          console.log(data.message);
        },
      });
    };

    // Save stuff
    self.save_admin_ranking = function () {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/artist-ranking",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          admin_ranking: self.new_admin_ranking(),
          artist_uuid: self.artist_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.admin_ranking(data.admin_ranking);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_payout_allow_transfer = function (allow_transfer) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/payout-allow-transfer",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          allow_transfer: allow_transfer,
          artist_uuid: self.artist_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.allow_payout_transfer(allow_transfer);
            self.new_allow_payout_transfer(allow_transfer);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_allow_attachments = function (allow_attachments) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/allow-attachments",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          allow_transfer: allow_transfer,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.allow_attachments(allow_attachments);
            self.new_allow_attachments(allow_attachments);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };


    self.set_no_gig_options = function (no_gig_option) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/no-gig-option",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          no_gig_options: no_gig_option,
          artist_uuid: self.artist_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.no_gig_options(no_gig_option);
            self.new_no_gig_options(no_gig_option);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.admin_deny_message = ko.observable();
    self.admin_deny_pro = function () {
      var answer = confirm(
        "You are denying pro for " + self.artist_name() + ". Correct?"
      );

      if (answer) {
        self.rootvm.is_busy(true);
        return $.ajax({
          url: self.rootvm.web_host + "/api/admin/artist-deny",
          type: "POST",
          data: ko.toJSON({
            artist_uuid: self.artist_uuid(),
            message: self.admin_deny_message(),
          }),
          processData: false,

          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              data.current_state.rootvm = self.rootvm;
              self.current_state(new ArtistStateAction(data.current_state));
              self.new_state(self.current_state().artist_state());
              notyf.success("Saved!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (jqXHR, errorStatus, thrownError) {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          },
          complete: function () {
            self.rootvm.is_busy(false);
          },
        });
      }
    };
	self.clearing_cache = ko.observable(false);
	self.clear_profile_amazon_cache = async function() {

	  self.clearing_cache(true);
	  try {
		// Make the POST request to the endpoint
		const response = await fetch('/api/admin/artist/clear-amazon-cache', {
		  method: 'POST',
		  body: JSON.stringify({'artist_uuid': self.artist_uuid()}),
		  headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		  }
		});

		// Check if the request was successful
		if (!response.ok) {
		  throw new Error(`Failed to clear cache:
				${response.status} ${response.statusText}`);
		}

		// Parse and return the response data
		const data = await response.json();
		console.log('Cache invalidation successful:', data);
		notyf.success('Cache cleared');
		self.clearing_cache(false);
		return data;

	  } catch (error) {
		console.error('Error clearing Amazon cache:', error);
  	    notyf.error("Server error -- failed to clear cache");
		self.clearing_cache(false);
		throw error;
	  }
	}

    // Approve artist
    self.admin_approve_message = ko.observable();
    self.admin_approve_pro = function () {
      self.rootvm.is_busy(true);
      return $.ajax({
        url: self.rootvm.web_host + "/api/admin/artist-approve",
        type: "POST",
        data: ko.toJSON({
          artist_uuid: self.artist_uuid(),
          message: self.admin_approve_message(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            data.current_state.rootvm = self.rootvm;
            self.current_state(new ArtistStateAction(data.current_state));
            self.new_state(self.current_state().artist_state());
            notyf.success("Saved!");

            const artistApproveModal = document.getElementById('artistApproveModal');
            Modal.getInstance(artistApproveModal)?.hide();

            if (data.emails) {
              if (data.emails) {
                window.open(data.emails[0], "_blank");
              }
            }
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {
          self.rootvm.is_busy(false);
          self.admin_approve_message(undefined);
        },
      });
    };

    self.admin_update_state = function () {
      if (self.new_state() == "confirmed") {
        alert("please use admin action");
      } else {
        self.rootvm.is_busy(true);
        return $.ajax({
          url: self.rootvm.web_host + "/api/admin/artist-update-state",
          type: "POST",
          data: ko.toJSON({
            artist_uuid: self.artist_uuid(),
            new_state: self.new_state(),
          }),
          processData: false,

          contentType: "application/json; charset=utf-8",

          success: function (data) {
            if (data.success) {
              data.current_state.rootvm = self.rootvm;
              self.current_state(new ArtistStateAction(data.current_state));
              self.new_state(self.current_state().artist_state());
              notyf.success("Saved!");
            } else {
              notyf.error(data.message);
            }
          },
          error: function (jqXHR, errorStatus, thrownError) {
            var response = jQuery.parseJSON(jqXHR.responseText);
            notyf.error(response.message);
          },
          complete: function () {
            self.rootvm.is_busy(false);
          },
        });
      }
    };
  }
}

export class ArtistFeedback {
  constructor(data) {
    var self = this;
    self.type = "ArtistFeedback";

    self.host_uuid = ko.observable(data.host_uuid);
    self.host_username = ko.observable(data.host_username);
    self.feedback_name = ko.observable(data.feedback_name);
    self.icon_path = ko.observable(data.icon_path);
    self.inserted = ko.observable(new moment(data.inserted));
    self.feedback = ko.observable(data.feedback);
    self.event_uuid = ko.observable(data.event_uuid);
    self.event_type = ko.observable(data.event_type);
    self.event_title = ko.observable(data.event_title);

    self.formatted_inserted = function (format) {
      if (self.inserted()) {
        return self.inserted().format(format);
      }
    };
  }
}

export class ArtistStateAction {
  constructor(data) {
    // Describes an Artist State Action
    //
    var self = this;
    self.type = "ArtistStateAction";

    self.rootvm = data.rootvm;

    self.artist_state_action = ko.observable(data.artist_state_action);
    self.artist_state = ko.observable(data.artist_state);
    self.inserted = ko.observable(new moment(data.inserted || null));

    self.effective_start = ko.observable();
    self.effective_end = ko.observable();
    if (data.effective) {
      self.effective_start(new moment(data.effective.lower));

      if (data.effective.upper.indexOf("9999") != 0) {
        self.effective_end(new moment(data.effective.upper));
      }
    }

    self.background_color_class = ko.computed(function () {
      if (self.artist_state() == "pro") {
        return "bg-success bg-opacity-25";
      } else if (self.artist_state() == "applied") {
        return "bg-danger bg-opacity-25";
      } else if (self.artist_state() == "confirmed") {
        return "bg-warning bg-opacity-25";
      } else {
        return "";
      }
    });

    // How long the artist stayed in this state. Uses the effective range end
    // when present, or "now" for the current (ongoing) state.
    self.duration_human = ko.computed(function () {
      var start = self.effective_start();
      if (!start) return "";
      var end = self.effective_end() || moment();
      return moment.duration(end.diff(start)).humanize();
    });

    self.is_current = ko.computed(function () {
      return !self.effective_end();
    });
  }
}
